var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36331 2.93333C9.36331 2.63878 9.12453 2.39999 8.82998 2.39999C8.53543 2.39999 8.29665 2.63878 8.29665 2.93333V7.46666H3.76331C3.46876 7.46666 3.22998 7.70544 3.22998 7.99999C3.22998 8.29454 3.46876 8.53333 3.76331 8.53333H8.29665V13.0667C8.29665 13.3612 8.53543 13.6 8.82998 13.6C9.12453 13.6 9.36331 13.3612 9.36331 13.0667V8.53333H13.8966C14.1912 8.53333 14.43 8.29454 14.43 7.99999C14.43 7.70544 14.1912 7.46666 13.8966 7.46666H9.36331V2.93333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.a514ddfb537b56f1cbc1e352e0076a3f.svg";
export { ForwardRef as ReactComponent };